export default __webpack_public_path__ + "static/media/maestro.fe0858ef.svg";